import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { getPaymentToken } from "../store/actions/payments";
import { signUpFollower } from "../store/actions/auth";
import { injectStripe } from 'react-stripe-elements';
import { showAlert } from '../store/actions/alert';
import {convertReadbleFormat} from './../helpers';
import { COLORS } from './../styles/colors';
import Card from './card'

const $ = window.$;

class AgencyNewUserModal extends Component {

    constructor(props){
        super(props)
        this.validator = new ReeValidate({
          email: 'required|email',
          password: 'required|min:3',
          confirmPassword: 'required',
          lastName: 'required',
          firstName: 'required',
        })
        this.state = {
          formData: {
            email: '',
            password: '',
            confirmPassword: '',
            firstName: '',
            lastName: ''
          },
          formErrors: this.validator.errors,
          isSubmit: false,
          isRevealPwd: false,
          isRevealConPwd: false,
          signUpError: null
        }
        this.paymentCard = React.createRef();
    }

    componentDidMount() {
        const { errors } = this.validator
        const { removeError } = this.props
        $('#enrollTrainer').on('hidden.bs.modal', () => {
          this.setState({
            formData: {
                email: '',
                password: '',
                confirmPassword: '',
                firstName: '',
                lastName: ''
            },
            signUpError: null,
            isRevealPwd: false,
            isRevealConPwd: false
          }, () => {
            errors.clear();
            removeError();
          });
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        const { removeError, isNCEP } = this.props
        removeError();
        const { formData, confirmPassErr } = this.state
        const { errors } = this.validator
        if (!confirmPassErr) {
          if(!isNCEP) {
            this.paymentCard.current.getWrappedInstance().handleSubmit()
            const paymentCardInstance = this.paymentCard.current.getWrappedInstance();
            const { isCardError, cardHolderName } = paymentCardInstance.state;
            this.validator.validateAll(formData).then(async(success) => {
              if (success) {
                if (isCardError) {
                  this.setState({
                    isSubmit: true,
                  });
                  const { showAlert } = this.props;
                  const res = await this.props.stripe.createToken({ name: cardHolderName });
                  if (res.error) {
                      const message = res.error.message;
                      showAlert(message, true);
                      this.setState({
                        isSubmit: false,
                      });
                  } else {
                    const token = res.token;
                    this.createNonce({ ...formData, isNCEP: false, token: token.id, email: formData.email.toLowerCase(), cardHolderName: cardHolderName });
                  }
                }
              } else {
                this.setState({ formErrors: errors });
              }
            });
          } else {
            this.validator.validateAll(formData)
            .then(success => {
              if (success) {
                this.createNonce({ ...formData, isNCEP: true, email: formData.email.toLowerCase() });
              } else {
                this.setState({ formErrors: errors })
              }
            })
          }
        }
    }

    toggleVisiblePassword(isConfirmPassword) {
      if (isConfirmPassword) {
        this.setState({
          isRevealConPwd: !this.state.isRevealConPwd
        })
      } else {
        this.setState({
          isRevealPwd: !this.state.isRevealPwd
        })
      }
    }

    async createNonce(formData) {

        const { signUpAgencyUser, showAlert } = this.props;
        let displayNames = [];
        if (formData.firstName) {
            displayNames.push(formData.firstName)
        }
        if (formData.lastName) {
          displayNames.push(formData.lastName)
        }
        signUpAgencyUser({
          email: formData.email,
          displayName: displayNames.join(' '),
          password: formData.password,
          isNCEP: formData.isNCEP,
          token: formData.token,
          type: 'brand'
        }).then((response) => {
            $('#enrollTrainer').modal('hide');
            this.props.showSuccessMessage();
            this.setState({
              isSubmit: false,
            });
        }).catch(error =>{
            this.setState({
              isSubmit: false,
              signUpError: error
            });
      });
    }

    handleChange = e => {
      const name = e.target.name
      const value = e.target.value
      const { errors } = this.validator
      errors.remove(name)
      this.setState({ formData: { ...this.state.formData, [name]: value } }, () => {
        this.validateConfirmPassword();
      })
      this.validator.validate(name, value)
        .then(() => {
          this.setState({ formErrors: errors })
        })
    }

    validateConfirmPassword() {
      const { password, confirmPassword } = this.state.formData;
      let confirmPassErr = '';
      if (password && confirmPassword && password !== confirmPassword) {
        confirmPassErr = 'Confirm password does not match';
      }
      this.setState({ confirmPassErr });
    }

   render() {
    const { formData, formErrors, isSubmit, isRevealPwd, isRevealConPwd, confirmPassErr, signUpError } = this.state
    const { isNCEP } = this.props;
    return (
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">&times;</button>
                <h3>{
                isNCEP ? 'Register for your own branded training app for free.' : 
                'Register today for only $49 per month. No contracts, cancel anytime.'
                }</h3>
                </div>
                <div style={{'padding':'50px', 'paddingTop': '25px'}} className="modal-body">
                <div className="row">
                  {signUpError !== null && <div className="alert alert-danger">{signUpError}</div>}
                  <form onSubmit={this.handleSubmit} noValidate>
                        <div className="form-group">
                          <label htmlFor="email">Log in email:</label>
                          <input type="email"
                              className="form-control"
                              id="email"
                              placeholder={isNCEP ? "Use same email address used to register for NCEP certification" : "Enter email address"}
                              name="email"
                              onChange={this.handleChange}
                              required
                              value={formData.email}/>
                          { formErrors.has('email') &&
                          <span className="error text-danger">{ convertReadbleFormat(formErrors.first('email')) }</span>
                          }
                    </div>
                    <div className="form-group" style={{
                      position: 'relative'
                    }}>
                      <label htmlFor="lname">Password:</label>
                      <input
                            type={isRevealPwd ? "text" : "password"}
                            className="form-control"
                            id="password"
                            name="password"
                            placeholder="Enter password"
                            onChange={this.handleChange}
                            required
                            value={formData.password}
                          />
                      <FontAwesomeIcon icon={ isRevealPwd ? faEyeSlash : faEye} title={'toggle'}
								          style={{
                            marginRight: '5px',
                            position: 'absolute',
                            right: '10px',
                            top: '48px',
                            color: COLORS.orange,
                            zIndex: '99999'
                          }}
                          onClick = {() => this.toggleVisiblePassword(false)} 
                      />
                      { formErrors.has('password') &&
                          <span className="error text-danger">{ convertReadbleFormat(formErrors.first('password')) }</span>
                      }
                  </div>

                  
                  <div className="form-group" style={{
                      position: 'relative'
                    }}>
                      <label htmlFor="lname">Confirm Password:</label>
                      <input
                            type={isRevealConPwd ? "text" : "password"}
                            className="form-control"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Enter password"
                            onChange={this.handleChange}
                            required
                            value={formData.confirmPassword}
                          />
                      <FontAwesomeIcon icon={ isRevealConPwd ? faEyeSlash : faEye} title={'toggle'}
								          style={{
                            marginRight: '5px',
                            position: 'absolute',
                            right: '10px',
                            top: '48px',
                            color: COLORS.orange,
                            zIndex: '99999'
                          }}
                          onClick = {() => this.toggleVisiblePassword(true)} 
                      />
                      { (formErrors.has('confirmPassword') || confirmPassErr) &&
                          <span className="error text-danger">
                            {(formErrors.has('confirmPassword') &&
                          convertReadbleFormat(formErrors.first('confirmPassword')))
                          || confirmPassErr}
                          </span>
                      }
                  </div>
                 
                  { !isNCEP &&
                   <Card isOtherCss={true}  ref={this.paymentCard}  brandIcon="brand-icon"></Card>
                  }

                  
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="firstName">First Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          placeholder="First name"
                          name="firstName"
                          onChange={this.handleChange}
                          required
                          value={formData.firstName}
                        />
                        {formErrors.has('firstName') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('firstName'))}
                          </span>
                        )}
                      </div>
                    </div>
                   
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="lastName">Last Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          placeholder="Last name"
                          name="lastName"
                          onChange={this.handleChange}
                          required
                          value={formData.lastName}
                        />
                        {formErrors.has('lastName') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('lastName'))}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                
                  
                  <div className="row">
                      <div className="col-md-12">
                      <button type="submit"  style={{ 'width': '100%' }}  className="btn circle btn-light border btn-md" disabled={isSubmit}>Finish</button>
                  </div>
                  </div>
                  </form>
                </div>
                </div>
                <div className="modal-footer">
                <button type="button"  className="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
            </div>

    )
  }
}

function mapStateToProps(state, ownProps) {
    return {
      paymentToken: state.payments.token
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      getPaymentToken: () => {
        return dispatch(getPaymentToken());
      },
      signUpFollower: (data) => {
        return dispatch(signUpFollower(data));
      },
      showAlert: (message, isError) => {
        return dispatch(showAlert(message, isError));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(injectStripe(AgencyNewUserModal));



// WEBPACK FOOTER //
// ./src/modals/agencyNewUser.js